import { baseTheme } from './baseTheme'
import { darkTheme } from './darkTheme'

const themes = {
  default: baseTheme,
  light: baseTheme,
  dark: darkTheme
}

export function applyThemeProperties (items = []) {
  items.forEach(item => {
    document.documentElement.style.setProperty(item.key, item.value)
  })
}

export function applyNamedTheme (themeName = 'default') {
  const theme = (themeName in themes) ? themes[themeName] : baseTheme

  document.documentElement.setAttribute('data-theme', themeName)
  document.documentElement.setAttribute('data-theme-type', theme.$type)

  applyThemeProperties(theme)
}

export function getDefaultThemeType () {
  const selectedTheme = localStorage.getItem('sws:selectedTheme') || 'default'
  return selectedTheme?.$type || 'default'
}

export function applyThemeDefaults () {
  const selectedTheme = localStorage.getItem('sws:selectedTheme') || 'default'

  applyNamedTheme(selectedTheme)
}

export function setThemeDefaults (themeName = 'default') {
  const theme = (themeName in themes) ? themeName : 'default'

  localStorage.setItem('sws:selectedTheme', theme)
}

global.__applyThemeProperties = applyThemeProperties
global.__applyNamedTheme = applyNamedTheme
global.__setThemeDefaults = setThemeDefaults
